import React from 'react';
import { history } from 'store/configureStore';
import { admAccounts, programFiles } from 'const';

/**
 * 開発用ロガー
 */
export const consoleLogger = (label = '', obj = '') => {
  if (process.env.NODE_ENV === 'development' && typeof console.log !== 'undefined') {
    console.log(label, obj);
  }
};

/**
 * sleep
 */
export const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));


/**
 * 現在が管理者アカウント関連画面の場合trueを返却
 */
export const isAccountPage = () => {
  const found = admAccounts.find((pageVal) => {
    const page = pageVal.replace(/:[0-9a-zA-Z_-]*/g, '[^/]*');
    const reg = new RegExp(page);
    if (history.location.pathname.match(reg)) {
      return true;
    }
    return false;
  });

  if (typeof found !== 'undefined') {
    return true;
  }

  return false; 
};

/**
 * 現在がプログラムファイル関連画面の場合trueを返却
 */
export const isProgramFilePage = () => {
  const found = programFiles.find(function(pageVal) {
    const page = pageVal.replace(/:[0-9a-zA-Z_-]*/g, '[^/]*');
    const reg = new RegExp(page);
    if (history.location.pathname.match(reg)) {
      return true;
    }
    return false;
  });

  if (typeof found !== 'undefined') {
    return true;
  }

  return false;
};

/**
 * React用のnl2br
 */
export const nl2br = (text) => {
  if (!text) {
    return '';
  }
  const regex = /(\n)/g;
  return text.split(regex).map(function (line, i) {
    if (line.match(regex)) {
      return React.createElement('br', { key: i});
    }
    else {
      return line;
    }
  });
};

export const sortArrayObject = (items, key, isAsc) => {
  if (isAsc) {
    return items.sort((a, b) => {
      if (a[key] > b[key]) {
        return 1;
      } else if (a[key] === b[key]) {
        return 0;
      } else {
        return -1;
      }
    });
  } else {
    return items.sort((a, b) => {
      if (a[key] < b[key]) {
        return 1;
      } else if (a[key] === b[key]) {
        return 0;
      } else {
        return -1;
      }
    });
  }
};

/**
 * タイムスタンプをYYYY-MM-dd hh:mm:ss形式に変換する
 * @param {object} timestamp 
 */
export const convertTimestampToDate = (timestamp) => {
  const d = new Date(timestamp);
  const year  = d.getFullYear();
  const month = (d.getMonth() + 1 < 10) ? '0' + (d.getMonth() + 1)  : (d.getMonth() + 1);
  const day   = (d.getDate() < 10) ? '0' + d.getDate()   : d.getDate();
  const hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours();
  const min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes();
  const sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds();
  const month_str = ((month / 10) === 0) ? '0' + month : month;
  return  (year + '-' + month_str + '-' + day + ' ' + hour + ':' + min + ':' + sec );
};

/**
 * タイムスタンプをyyyymmddの形式に変換する
 * @param {object} timestamp 
 */
export const getDateToYMDStr = (timestamp) => {
  const date = new Date(timestamp);
  const Y = date.getFullYear();
  const M = ('00' + (date.getMonth()+1)).slice(-2);
  const D = ('00' + date.getDate()).slice(-2);
  return Y + M + D;
};

/**
 * ユニークIDを生成する
 * @return {string} ユニークID
 */
export const createUniqueStr = () => {
  return new Date().getTime().toString(16);
};

/**
 * Invalid Date かを判定する
 * @param {object} date 
 */
export const isInvalidDate = (date) => Number.isNaN(date.getDate());